<script lang="ts">
  import "@lottiefiles/lottie-player";
  import type { AnimationsConfig } from "../declarations/config";
  import { PlayerState, type LottiePlayer } from "@lottiefiles/lottie-player";
  import { playDialogue, playSound, stopSound } from "../utils/AudioManager";
  import {
    sendInteractionEvent,
    INTERACTION_TYPE_ANIMATION,
  } from "../utils/analytics";
  import { appStarted, assetsLoaded } from "../store/AppState";

  // Check: https://github.com/LottieFiles/svelte-lottie-player/blob/master/src/components/utils.js
  let player: LottiePlayer;
  let idlePlayer: LottiePlayer;

  export let config: AnimationsConfig;
  export let index: number;
  export let onLoad: () => void;
  export let allLoaded: boolean;

  let idleLoaded = false;
  let activeLoaded = false;
  const handleLoad = (lottiePlayer: LottiePlayer, idle: boolean) => {
    lottiePlayer.getLottie().setSubframe(false);
    onLoad();

    if (idle) {
      idleLoaded = true;
    }
    if (!idle) {
      activeLoaded = true;
    }
  };

  const handleKeydown = () => {};

  let showIdle = true;

  let dialogueCounter = 0;

  const handlePlay = () => {
    if (!activeLoaded) {
      return;
    }
    if (player.currentState === PlayerState.Playing) {
      return;
    }
    idlePlayer.stop();
    idlePlayer.seek(0);
    showIdle = false;

    player.seek(0);
    player.play();

    playSound(config.order - 1);
    const animationsWithDialogue = [3, 4, 6, 12, 13, 14, 16, 22];
    if (animationsWithDialogue.includes(config.order)) {
      const position = animationsWithDialogue.indexOf(config.order);
      playDialogue(position * 3, dialogueCounter);
      dialogueCounter++;
      if (dialogueCounter > 2) {
        dialogueCounter = 0;
      }
    }
    sendInteractionEvent(INTERACTION_TYPE_ANIMATION, config.name);
  };

  const handleComplete = () => {
    player.stop();
    player.seek(0);
    showIdle = true;

    idlePlayer.play();

    if (config.name === "princeznicka") {
      lightsOut = true;
      setTimeout(() => {
        lightsOut = false;
      }, 1500);
    }
  };

  const handleEnterFrame = () => {
    const currentFrame = player.getLottie().currentFrame;
    if (config.name === "princeznicka") {
      if (
        [83, 86, 87, 88, 92, 93, 95].includes(currentFrame) ||
        currentFrame > 95
      ) {
        lightsOut = true;
      } else {
        lightsOut = false;
      }
    }
  };

  $: lightsOut = false;

  let animationName = `${config.name}-mobile`;

  let firstPlay = true;

  const handleIndexChange = () => {
    if (config.order === index && allLoaded && $appStarted) {
      if (firstPlay) {
        handlePlay();
        firstPlay = false;
      }
    } else {
      if (idlePlayer && player) {
        idlePlayer.stop();
        player.stop();
        stopSound(config.order - 1);
        firstPlay = true;
      }
    }
  };

  $: if (index) {
    handleIndexChange();
  }

  appStarted.subscribe((value: boolean) => {
    if (value) {
      handleIndexChange();
    }
  });

  assetsLoaded.subscribe((value: boolean) => {
    if (value) {
      handleIndexChange();
    }
  });
</script>

<div
  class="wrapper"
  style={`visibility: ${
    config.order === index && allLoaded ? "visible" : "hidden"
  }`}
>
  <div
    class="hitbox"
    on:pointerup={() => handlePlay()}
    on:keydown={handleKeydown}
    tabindex={index}
    role="button"
    style={`z-index: ${config.layer ? config.layer + 10 : 0}`}
  ></div>
  <div class="lottie-container" style={`--zIndex: ${config.layer};`}>
    <lottie-player
      bind:this={idlePlayer}
      src={`${__PUBLIC_PATH__}bodymovin/${config.name}/idle/${animationName}.json`}
      mode="normal"
      loop={true}
      speed="1"
      on:load={() => handleLoad(idlePlayer, true)}
      autoplay={false}
      style={`display: ${
        showIdle === false ? "none" : "block"
      }; width: 100%; height: ${
        __MODE__ === "production" ? "calc(100vh - 6.4rem)" : "100vh"
      }`}
    />
    {#if idleLoaded}
      <lottie-player
        bind:this={player}
        on:load={() => handleLoad(player, false)}
        on:complete={() => handleComplete()}
        on:frame={() => handleEnterFrame()}
        src={`${__PUBLIC_PATH__}bodymovin/${config.name}/${animationName}.json`}
        mode="normal"
        speed="1"
        autoplay={false}
        style={`display: ${
          showIdle === false ? "block" : "none"
        }; width: 100%; height: ${
          __MODE__ === "production" ? "calc(100vh - 6.4rem)" : "100vh"
        }`}
      />
    {/if}
  </div>
  {#if lightsOut}
    <div class="lights-out" />
  {/if}
</div>

<style>
  .lottie-container {
    z-index: var(--zIndex);
    position: absolute;
    width: 200%;
    left: -50%;
    top: -5%;
  }

  .hitbox {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    cursor: default;
  }

  .lights-out {
    width: 100%;
    height: 100%;
    z-index: 1000000;
    background-color: black;
    position: absolute;
    top: 0;
    left: 0;
  }
</style>
